module.exports = __webpack_public_path__ + "img/20190612161845845.0cfdb2da.png";